import { ReactComponent as ImageIcon } from "assets/svgs/Image.svg";

const SkeletonImage = () => {
    return (
        <div className="flex h-full w-full animate-pulse  items-center justify-center rounded-r10 bg-black80 bg-black90">
            <ImageIcon className="h-16 w-16" />
        </div>
    );
};

export default SkeletonImage;
